import HttpUtil from "@/utils/HttpUtil";

/**
 * 设置项服务
 */
export default {
    /**
     * 获取列表
     * @param kw
     * @returns {Promise<unknown>}
     */
    getPageList(pageNum,pageSize,kw){
        return new Promise((resolve,reject)=>{
            HttpUtil.postJson("/data-center-provider/settingItem/pageList",{
                kw,pageNum,pageSize
            }).then(res=>{
                if (res.code === "ok"){
                    resolve(res.body);
                }else{
                    reject(res.msg);
                }
            }).catch(e=>{
                reject("网络请求异常");
            })
        });
    },
    /**
     * 添加文档模板
     */
    add(params){
        return new Promise((resolve,reject)=>{
            HttpUtil.postJson("/data-center-provider/settingItem/create",params).then(res=>{
                if (res.code === "ok"){
                    resolve(res.body);
                }else{
                    reject(res.msg);
                }
            }).catch(e=>{
                reject("网络请求异常");
            })
        });
    },
    /**
     * 更新文档模板
     */
    update(key,params){
        return new Promise((resolve,reject)=>{
            HttpUtil.postJson("/data-center-provider/settingItem/update/"+key,params).then(res=>{
                if (res.code === "ok"){
                    resolve(res.body);
                }else{
                    reject(res.msg);
                }
            }).catch(e=>{
                reject("网络请求异常");
            })
        });
    },
    delete(key){
        return new Promise((resolve,reject)=>{
            HttpUtil.post("/data-center-provider/settingItem/delete/"+key,{}).then((re)=>{
                if (re.code === "ok"){
                    resolve(re.body);
                }else{
                    reject(re.msg);
                }
            }).catch((e)=>{
                console.log("删除文档模板异常",e);
                reject(e);
            })
        });
    },
    //切换启用状态
    switchEnable(key,enable){
        return new Promise((resolve,reject)=>{
            HttpUtil.post("/data-center-provider/settingItem/switchEnable/"+key,{enable}).then(res=>{
                if (res.code === "ok"){
                    resolve(res.body);
                }else{
                    reject(res.msg);
                }
            }).catch(e=>{
                reject("网络请求异常");
            })
        });
    }
}
